module.exports = __webpack_public_path__ + "static/media/vi_flag.874f1f5f.svg";